import apiClient from '../utils/axiosConfig';

// Servicio para gestionar misiones
const missionService = {
  // Obtener todas las misiones (solo para staff)
  getAllMissions: async () => {
    try {
      const response = await apiClient.get('/missions/');
      return response.data;
    } catch (error) {
      console.error('Error al obtener todas las misiones:', error);
      return [];
    }
  },

  // Obtener misiones de la empresa del usuario
  getEnterpriseMissions: async () => {
    try {
      const response = await apiClient.get('/missions/by-enterprise/');
      return response.data;
    } catch (error) {
      console.error('Error al obtener misiones de la empresa:', error);
      return [];
    }
  },

  // Obtener misiones asignadas al piloto
  getPilotMissions: async () => {
    try {
      const response = await apiClient.get('/missions/by-pilot/');
      return response.data;
    } catch (error) {
      console.error('Error al obtener misiones del piloto:', error);
      return [];
    }
  },

  // Obtener una misión por ID
  getMissionById: async (id) => {
    try {
      const response = await apiClient.get(`/missions/${id}/`);
      return response.data;
    } catch (error) {
      console.error(`Error al obtener misión ${id}:`, error);
      throw error;
    }
  },

  // Obtener puntos de una misión
  getMissionPoints: async (missionId) => {
    try {
      const response = await apiClient.get(`/mission-points/by-mission/${missionId}/`);
      return response.data;
    } catch (error) {
      console.error(`Error al obtener puntos de la misión ${missionId}:`, error);
      return [];
    }
  },

  // Crear una nueva misión
  createMission: async (missionData) => {
    try {
      const response = await apiClient.post('/missions/', missionData);
      return response.data;
    } catch (error) {
      console.error('Error al crear misión:', error);
      throw error;
    }
  },

  // Actualizar una misión existente
  updateMission: async (id, missionData) => {
    try {
      const response = await apiClient.patch(`/missions/${id}/`, missionData);
      return response.data;
    } catch (error) {
      console.error(`Error al actualizar misión ${id}:`, error);
      throw error;
    }
  },

  // Asignar un piloto a una misión
  assignPilot: async (missionId, pilotId) => {
    try {
      const response = await apiClient.post(`/missions/${missionId}/assign-pilot/`, { pilot_id: pilotId });
      return response.data;
    } catch (error) {
      console.error(`Error al asignar piloto a misión ${missionId}:`, error);
      throw error;
    }
  },

  // Asignar un aircraft a una misión
  assignAircraft: async (missionId, aircraftId) => {
    try {
      const response = await apiClient.post(`/missions/${missionId}/assign-aircraft/`, { aircraft_id: aircraftId });
      return response.data;
    } catch (error) {
      console.error(`Error al asignar aircraft a misión ${missionId}:`, error);
      throw error;
    }
  },

  // Verificar si una misión tiene puntos
  hasMissionPoints: async (missionId) => {
    try {
      const response = await apiClient.get(`/missions/${missionId}/has-points/`);
      return response.data;
    } catch (error) {
      console.error(`Error al verificar puntos de misión ${missionId}:`, error);
      return { has_points: false };
    }
  },

  // Exportar misión a KMZ para DJI Pilot 2
  exportMissionKMZ: async (missionId) => {
    try {
      const response = await apiClient.get(`/missions/${missionId}/export-kmz/`, {
        responseType: 'blob',
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `mission-${missionId}.kmz`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      return true;
    } catch (error) {
      console.error(`Error al exportar misión ${missionId} a KMZ:`, error);
      throw error;
    }
  },

  // Obtener todos los reportes (solo para staff)
  getAllReports: async () => {
    try {
      const response = await apiClient.get('/reports/');
      return response.data;
    } catch (error) {
      console.error('Error al obtener todos los reportes:', error);
      return [];
    }
  },

  // Obtener reportes de la empresa del usuario
  getEnterpriseReports: async () => {
    try {
      const response = await apiClient.get('/reports/by-enterprise/');
      return response.data;
    } catch (error) {
      console.error('Error al obtener reportes de la empresa:', error);
      return [];
    }
  },

  // Generar puntos automáticamente para una misión
  generateAutoPoints: async (missionId, params = {}) => {
    try {
      const response = await apiClient.post('/mission-points/generate-auto/', {
        mission_id: missionId,
        ...params,
      });
      return response.data;
    } catch (error) {
      console.error(`Error al generar puntos automáticos para misión ${missionId}:`, error);
      throw error;
    }
  },
};

export default missionService;
